interface UpdateItem {
  time: string;
  tag: string;
  title: string;
  hot: boolean;
}

const updateItems: UpdateItem[] = [
  { time: '15分钟前', tag: '爆料', title: '某顶流男星深夜密会神秘女子，酒店同框照曝光引热议', hot: true },
  { time: '42分钟前', tag: '实锤', title: '知名女星工作室发布律师函，否认整容传闻并追究造谣者责任', hot: true },
  { time: '1小时前', tag: '视频', title: '综艺录制现场突发意外，嘉宾当场翻脸节目组紧急叫停', hot: false },
  { time: '2小时前', tag: '深扒', title: '某带货主播被曝虚假宣传，工商部门已介入调查产品质量', hot: true },
  { time: '3小时前', tag: '快讯', title: '热门剧集男女主片场互动亲密，疑因戏生情引粉丝热议', hot: false },
  { time: '5小时前', tag: '追踪', title: '此前塌房网红新账号被封禁，平台回应：永久禁止入驻', hot: false },
  { time: '7小时前', tag: '独家', title: '某音乐节主办方跑路，多名艺人演出费被拖欠引发行业关注', hot: false },
];

const SectionUpdates = () => (
  <section id="updates" className="py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新快讯</h2>
        <p className="mt-2 text-sm text-foreground-500">24小时滚动更新，吃瓜永不断档</p>
      </div>
      <div className="max-w-[800px] mx-auto">
        {updateItems.map((item, i) => (
          <div key={i} className="relative flex gap-4 pb-6 last:pb-0">
            {i < updateItems.length - 1 && (
              <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-300"></div>
            )}
            <div className={`flex-shrink-0 w-[38px] h-[38px] rounded-full flex items-center justify-center ${
              item.hot ? 'bg-primary-500' : 'bg-secondary-400'
            }`}>
              <i className={`${item.hot ? 'ri-fire-fill' : 'ri-time-line'} text-background-50 text-sm`}></i>
            </div>
            <div className="flex-1 min-w-0 pt-1.5">
              <div className="flex flex-wrap items-center gap-2 mb-1">
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${
                  item.hot ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
              </div>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SectionUpdates;